/* eslint-disable max-len */
import React from 'react';

const CheckedIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M0 12.116l2.053-1.897c2.401 1.162 3.924 2.045 6.622 3.969 5.073-5.757 8.426-8.678 14.657-12.555L24 3.169c-5.139 4.484-8.902 9.479-14.321 19.198C6.336 18.431 4.105 15.921 0 12.116z' />
  </svg>
);

export default CheckedIcon;
